export const contactsMap = () => {
  const contactsMapElement = document.querySelector(`.js-contacts-map`);

  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  if (contactsMapElement) {
    let myMap;
    let myPlacemark;

    ymaps.ready(init);

    function init() {
      myMap = new ymaps.Map(
        "map",
        {
          center: [59.927897, 30.314799],
          zoom: isMobile ? 12 : 14,
          controls: [],
        },
        {
          searchControlProvider: "yandex#search",
        },
        (myPlacemark = new ymaps.Placemark(
          [59.927897, 30.314799],
          {
            balloonContentHeader: `Наш офис`,
            balloonContent: "<p>Адрес: Россия, Санкт-Петербург, наб. Канала Грибоедова, д.59</p>",
          },
          {
            iconLayout: "default#image",
            iconImageHref: "/img/contacts/tezis-map-icon.svg",
            iconImageSize: isMobile ? [31, 43] : [60, 84],
            iconImageOffset: isMobile ? [15.5, -43] : [-40, -84],
          },
        )),
      );
      myMap.geoObjects.add(myPlacemark);
    }
  }
};
